import React from 'react';

import '../styles.scss';
import SupportCard from '../../../components/SupportCard';

const CardsSupport = ({ contactInfo }) => {
  return (
    <div className="welcome-cards-support-wrapper">
      {contactInfo.map((contact, idx) => (
        <SupportCard key={idx} contact={contact} />
      ))}
    </div>
  );
};

export default CardsSupport;
